<app-header-home [walletS]="walletS"></app-header-home>
<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-item lines="none ion-text-center">
          <ion-label>Lo sentimos, esta opción no está disponible fuera de México</ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<app-tab-bar></app-tab-bar>
